module.exports = __webpack_public_path__ + "img/lasource-6.07224078.jpg";